<template>
	<!-- 岗位排查栏目管理 -->
	<section>
		
		<!--列表-->
		<el-table :data="companylist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
      		<el-table-column prop="cityName" label="所属城市"  align="center" min-width="100">
		 	</el-table-column>			
      		<el-table-column prop="workerTypeName" label="岗位名称"  align="center" min-width="100">
		 	</el-table-column>

       		<el-table-column prop="riskLevelName" label="风险级别" align="center" min-width="100">
			</el-table-column>

			<el-table-column prop="checkContent" label="检查内容" align="center"  min-width="200">
			</el-table-column>

			<el-table-column prop="isClose" label="状态" align="center" min-width="100" >
				<template slot-scope="scope">
				<!-- 不同状态显示不同颜色的文字 -->
				<div v-if='scope.row.isClose==="0"'>
					<span style="color: green;">启用</span>
				</div>
					
				<div v-else>
					<span style="color: red;">禁用</span>
				</div>
				</template>
			</el-table-column>

			<el-table-column label="操作" align="center" width="100">
				<template slot-scope="scope">
					<el-button v-if="scope.row.isClose=='0'"  type="danger" size="small" @click="handleClose(scope.$index, scope.row)">禁用</el-button>
					<el-button v-if="scope.row.isClose=='1'" type="success" size="small" @click="handleOpen(scope.$index, scope.row)">启用</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
	</section>
</template>

<script>
	import {getGwCheckItem,updateGwCheckItem} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id

				companylist: [],
				total: 0,
				page: 1,
				listLoading: false,			
			}
		},
		methods: {
			
			handleCurrentChange(val) {				
				this.page = val;
				this.getListPage();
			},
			//获取列表
			getListPage() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
				};

				this.listLoading = true;

				getGwCheckItem(para).then((res) => {


					if(res.data.code==0){
						this.total = res.data.data.total;
						this.companylist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			handleClose: function (index, row) {
				this.$confirm('确认禁用这个检查栏目吗？', '提示', {}).then(() => {

					let newparam={
						createUserId:this.objectId,
						checkItemId:row.checkItemId,
						isClose:'1'
					}

					updateGwCheckItem(newparam).then((res) => {
						if(res.data.code==0){
						this.$message.success(res.data.message);
						this.getListPage();
						}
						else{
						this.$message.error(res.data.message);
						}
					});
				});	
			
			},
			
			handleOpen: function (index, row) {
				this.$confirm('确认启用这个检查栏目吗？', '提示', {}).then(() => {

					let newparam={
						createUserId:this.objectId,
						checkItemId:row.checkItemId,
						isClose:'0'
					}

					updateGwCheckItem(newparam).then((res) => {
						if(res.data.code==0){
						this.$message.success(res.data.message);
						this.getListPage();
						}
						else{
						this.$message.error(res.data.message);
						}
					});
				});	
			},
		
			
		
			
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.getListPage();
		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// gwCheckItem.vue?2a7fc590